import React, { useEffect, useState } from "react";
import { getKiteCredentials, saveKiteCredentials } from "../api";

export default function KiteSettings({ onSaved }) {
  const [hasCredentials, setHasCredentials] = useState(null); // null = loading
  const [apiKeyMasked, setApiKeyMasked] = useState(null);
  const [apiKey, setApiKey] = useState("");
  const [apiSecret, setApiSecret] = useState("");
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  const load = () => {
    getKiteCredentials()
      .then((res) => {
        setHasCredentials(res.data.has_credentials);
        setApiKeyMasked(res.data.api_key_masked);
      })
      .catch((err) => setError(err.response?.data?.detail || err.message));
  };

  useEffect(load, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setMessage(null);
    if (!apiKey.trim() || !apiSecret.trim()) {
      setError("Both API key and API secret are required.");
      return;
    }
    setBusy(true);
    try {
      await saveKiteCredentials(apiKey.trim(), apiSecret.trim());
      setApiKey("");
      setApiSecret("");
      setMessage("Saved. You can now click Connect Kite in the header.");
      load();
      if (onSaved) onSaved();
    } catch (err) {
      setError(err.response?.data?.detail || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="strategy-panel">
      <p className="hint" style={{ marginTop: 0 }}>
        This dashboard doesn't share one Kite API key between everyone - each account connects its
        own personal Kite Connect app, so your orders only ever touch your own Zerodha account.
      </p>

      <ol style={{ fontSize: 13, color: "#9aa4b2", paddingLeft: 18, marginBottom: 16 }}>
        <li>
          Create a free app at{" "}
          <a href="https://developers.kite.trade/apps" target="_blank" rel="noopener noreferrer">
            developers.kite.trade/apps
          </a>{" "}
          under your own Zerodha login.
        </li>
        <li>Set its Redirect URL to this dashboard's own address (same one you're using now).</li>
        <li>Copy the API key and API secret it gives you into the form below.</li>
        <li>
          Add this server's IP address to that app's IP Whitelist (Profile page) - use the same
          server IP everyone else here has already whitelisted under their own app; that's not a
          conflict, whitelisting isn't exclusive to one app.
        </li>
      </ol>

      {hasCredentials === true && (
        <div className="banner info">Currently saved: {apiKeyMasked}. Enter new values below to replace it.</div>
      )}
      {hasCredentials === false && (
        <div className="banner error">No Kite API key saved yet - Connect Kite won't work until you add one.</div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="field-group">
          <label>Your Kite API key</label>
          <input type="text" value={apiKey} onChange={(e) => setApiKey(e.target.value)} autoComplete="off" />
        </div>
        <div className="field-group">
          <label>Your Kite API secret</label>
          <input type="password" value={apiSecret} onChange={(e) => setApiSecret(e.target.value)} autoComplete="off" />
        </div>

        {error && <div className="banner error">{error}</div>}
        {message && <div className="banner info">{message}</div>}

        <button type="submit" disabled={busy}>
          {busy ? "Saving..." : "Save Kite credentials"}
        </button>
      </form>
    </div>
  );
}
